import React from 'react';
import { Categories, Category } from 'module/Model/Categories';
import { CategoriesSelector } from 'module/Redux/Categories';
import { connect } from 'react-redux';
import { createPureComponent } from 'module/Common';
import { ItemsGrid } from 'module/View/ItemsGrid';
import { LinksWrapper } from './NextPosts.s';
import { Localized } from 'module/Model/Localized';
import { LocalizedRenderer, LocalizedText, WishHandler, MountedStateProvider } from 'module/View/Common';
import { NextCategoriesLinks } from './NextCategoriesLinks';
import { PostList } from 'module/Model/PostList';
import { PostListSelector } from 'module/Redux/PostList';
import { State } from 'module/Redux';
import { Wish } from 'module/Model/Wish';
import posed from 'react-pose';
import { RouterSelector } from 'module/Redux/Router';

const CategoriesHandler = WishHandler.create<Array<Category>>();
const CategoryHandler = WishHandler.create<Category>();

type StateProps = {
  nextPostsWish: Wish<PostList>;
  categoriesWish: Wish<Categories>;
  nextCategoryWish: Wish<Category> | null;
  routeIsInExitState: boolean;
};

const FadeOut = posed.div({
  init: { opacity: 0 },
  normal: { opacity: 1 },
  exit: { opacity: 0 },
});

const mapStateToProps = (s: State): StateProps => ({
  nextPostsWish: PostListSelector.selectNextPosts(s),
  categoriesWish: CategoriesSelector.selectNextLinks(s),
  nextCategoryWish: CategoriesSelector.nextCategory(s),
  routeIsInExitState: RouterSelector.routeIsInExitState(s),
});

type OwnProps = {
  availableWidth: number;
};

type Props = StateProps & OwnProps;

const NextPostsComp = createPureComponent<Props>(
  'NextPosts',
  ({ nextPostsWish, categoriesWish, nextCategoryWish, availableWidth, routeIsInExitState }) => {
    return (
      <>
        <MountedStateProvider>
          {mounted => {
            const pose = routeIsInExitState ? 'exit' : mounted ? 'normal' : 'init';
            return (
              <FadeOut pose={pose}>
                <CategoriesHandler
                  wish={categoriesWish}
                  handlePending={() => <LocalizedRenderer renderFr={() => 'Chargement'} renderEn={() => 'Loading'} />}
                  handleResolved={categories => {
                    const basicCats = Categories.filterBasics(categories);
                    const clientCats = Categories.filterClients(categories);

                    return (
                      <LinksWrapper>
                        <NextCategoriesLinks
                          categories={basicCats}
                          single={Localized.create('Catégorie > ', 'Category > ')}
                          multiple={Localized.create('Catégories > ', 'Categories > ')}
                        />
                        <NextCategoriesLinks
                          categories={clientCats}
                          single={Localized.create('Client > ', 'Client > ')}
                          multiple={Localized.create('Clients > ', 'Clients > ')}
                        />
                      </LinksWrapper>
                    );
                  }}
                />
              </FadeOut>
            );
          }}
        </MountedStateProvider>
        <ItemsGrid
          postListWish={nextPostsWish}
          availableWidth={availableWidth}
          nameTile={
            nextCategoryWish && (
              <CategoryHandler
                wish={nextCategoryWish}
                handleResolved={category => {
                  return <LocalizedText content={Category.getName(category)} />;
                }}
              />
            )
          }
        />
      </>
    );
  }
);

export const NextPosts = connect(mapStateToProps)(NextPostsComp);



// WEBPACK FOOTER //
// ./src/module/View/NextPosts/NextPosts.tsx